export default __webpack_public_path__ + "static/media/business.412246d1.svg";